import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CONFIG, ENV } from '@tnq/shared/config';
import { AppLanguage, IAppConfig, IEnv } from '@tnq/shared/types';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private translate = inject(TranslateService);
  private environment = inject<IEnv>(ENV);
  private config = inject<IAppConfig>(CONFIG);

  private languageStorageKey = 'tnq-language-key';
  private languageOptions = [''];

  constructor() {
    const config = this.config;

    this.languageOptions = config.languageOptions;
  }

  public initialize() {
    this.translate.addLangs(this.languageOptions);
    this.translate.setDefaultLang(this.environment.defaultLang);
    this.setLanguage(
      this.loadPreviousLanguage() ||
        (this.environment.defaultLang as AppLanguage),
    );
  }

  public setLanguage(language: AppLanguage) {
    const validatedLang = this.validateLanguage(language);
    this.translate.use(validatedLang);
    this.saveLanguage(validatedLang);
  }

  public getLanguage() {
    return this.translate.currentLang;
  }

  private loadPreviousLanguage(): AppLanguage {
    return this.validateLanguage(
      localStorage.getItem(this.languageStorageKey) as AppLanguage,
    );
  }

  private saveLanguage(language: AppLanguage) {
    localStorage.setItem(this.languageStorageKey, language);
  }

  private validateLanguage(language: AppLanguage): AppLanguage {
    if (language && !this.languageOptions.includes(language)) {
      console.warn(
        `Language '${language}' is not supported. Using fallback '${this.environment.defaultLang}'.`,
      );
      language = this.environment.defaultLang as AppLanguage;
    }

    return language;
  }
}
